export enum Roles {
  Admin = 'admin',
  SuperAdmin = 'superadmin',
  User = 'user',
  ExternalUser = 'externaluser',
  CEO = 'ceo',
}
